import { render } from "./SalesSpecial.vue?vue&type=template&id=32faa18c&lang=true"
import script from "./SalesSpecial.vue?vue&type=script&lang=js"
export * from "./SalesSpecial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__